import type { ResourceSearchFamily } from "@/db/definitions";
import {
  BookA,
  BookOpenText,
  Building2,
  LineChart,
  MapPin,
  Newspaper,
  ShieldCheck,
  Wind,
  type LucideIcon,
} from "lucide-react";

export const RESOURCE_FAMILY_ORDER: ResourceSearchFamily[] = [
  "ARTICLE",
  "GLOSSARY",
  "HANDBOOK",
  "MARKET",
  "PLATFORM",
  "INSURANCE",
  "LOCATION",
  "AIR_QUALITY",
];

export const RESOURCE_FAMILY_ICONS: Record<ResourceSearchFamily, LucideIcon> = {
  ARTICLE: Newspaper,
  GLOSSARY: BookA,
  HANDBOOK: BookOpenText,
  LOCATION: MapPin,
  MARKET: LineChart,
  PLATFORM: Building2,
  INSURANCE: ShieldCheck,
  AIR_QUALITY: Wind,
};

export const RESOURCE_FAMILY_HREFS: Record<ResourceSearchFamily, string> = {
  ARTICLE: "/resource/category",
  GLOSSARY: "/resource/glossary",
  HANDBOOK: "/resource/handbook",
  LOCATION: "/resource/location/city",
  MARKET: "/resource/market",
  PLATFORM: "/resource/platform",
  INSURANCE: "/resource/insurance",
  AIR_QUALITY: "/resource/air-quality",
};
